<template lang="html">
  <div class="category-page">
    <Banner
      :imageCoverURL="baseUrlStorage+data.background"
      :title="data.title"
      data-aos="fade-right"
      data-aos-duration="1000"
    />
    <section class="slider-wrapper">
      <div class="container">
        <div class="content-search">
          <div class="search">
            <InputSearch placeholder="Buscar" :setSearch="setSearch"/>
          </div>
        </div>
        <TitleObservatory text="Casos" 
          data-aos="fade-left"
          data-aos-duration="1000"
        />
        <div class="slider" v-if="category_type_cases.length">
          <ListCardCategoryInfo route="casos" :data="category_type_cases"/>
        </div>
        <div class="slider" v-else>
          Ningun Resultado para Casos
        </div>
        <TitleObservatory
          text="Situaciones ABP"
          data-aos="fade-right"
          data-aos-duration="1000"
        />
        <div class="slider"  v-if="category_type_situations.length">
          <ListCardCategoryInfo route="situaciones" :data="category_type_situations" />
        </div>
        <div class="slider" v-else>
          Ningun Resultado para Situaciones ABP
        </div>
        <TitleObservatory
          text="Bibliografía"
          data-aos="fade-down"
          data-aos-duration="1000"
        />
        <div class="slider"  v-if="category_type_biographies.length">
          <ListCardCategoryInfo route="bibliografia" :data="category_type_biographies" />
        </div>
        <div class="slider" v-else>
          Ningun Resultado para Bibliografía
        </div>
      </div>
      <div class="container video-wrapper">
        <div class="row">
          <div v-if="guide.state" class="col-12 col-lg-6 my-4">
            <CardFooterDownload
              :imageURL="baseUrlStorage+guide.imageURL"
              :title="guide.title"
              :description="guide.description"
              :link="baseUrlStorage+guide.file ? baseUrlStorage+guide.file :guide.link"
              buttonText="DESCARGA"
              data-aos="fade-up"
              data-aos-duration="1000"
            />
          </div>
          <div v-if="entrevista.state" class="col-12 col-lg-6 my-4">
            <router-link to="entrevistas">
              <VideoCategory
                :imageURL="baseUrlStorage+entrevista.imageURL"
                data-aos="fade-up"
                data-aos-duration="1200"
                img="baseUrlStorage+guide.file ? baseUrlStorage+entrevista.file :entrevista.link"
                :title="entrevista.title"
                :description="entrevista.description"
                buttonText="Ver Entrevista"
              />
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>
import Banner from "../components/General/Banner.vue";
import Footer from "../components/General/Footer.vue";

import ListCardCategoryInfo from "../components/Category/ListCardCategoryInfo.vue";
import VideoCategory from "../components/Category/VideoCategory.vue";

import CardFooterDownload from "../components/CardFooterDowload.vue";
import TitleObservatory from "../components/Observatory/TitleObservatory.vue";

import InputSearch from "../components/General/InputSearch.vue";
import { mapState, mapActions } from "vuex";

export default {
  inject: ['baseUrlStorage'],
  components: {
    Banner,
    Footer,
    ListCardCategoryInfo,
    VideoCategory,
    CardFooterDownload,
    TitleObservatory,
    InputSearch,
  },
  data() {
    return {
      category_type_cases:[],
      category_type_situations:[],
      category_type_biographies:[],
      guide:{},
      entrevista:{},
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.dataCategory,
    }),
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions(["getDataAdmin"]),
    getData() {
      var _this = this;
      this.getDataAdmin({
        url: "getCategory",
        type: "POST",
        params: { ref: this.$route.params.type },
      }).then(
        (res) => {
          console.log(res.data);
          _this.category_type_cases = res.data.category_type_cases;
          _this.category_type_situations = res.data.category_type_situations;
          _this.category_type_biographies = res.data.category_type_biographies;
          console.log({
            data: res.data,
          })
          _this.guide = res.data.guide;
          _this.entrevista = res.data.entrevista;
          this.$store.commit("SET_DATA_CATEGORY", {
            data: res.data,
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
    setSearch(word){
      this.category_type_cases = this.data.category_type_cases.filter(item => item.title.toLowerCase().indexOf(word.toLowerCase()) > -1);
      this.category_type_situations = this.data.category_type_situations.filter(item => item.title.toLowerCase().indexOf(word.toLowerCase()) > -1);
      this.category_type_biographies = this.data.category_type_biographies.filter(item => item.title.toLowerCase().indexOf(word.toLowerCase()) > -1);
    }
  },
};
</script>
<style lang="css" scoped>
.category-page .content-search {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.category-page .content-search .search {
  width: 400px;
  margin-bottom: -100px;
}
@media (max-width: 768px) {
  .category-page .content-search .search {
    width: 100%;
    margin-bottom: 30px;
  }
}
.category-page .slider-wrapper {
  background: radial-gradient(
    69% 69% at 50% 31%,
    rgba(51, 100, 126, 0.97) 0%,
    rgba(1, 54, 82, 0.97) 100%
  );
  padding: 60px 0;
}
.category-page .slider-wrapper .slider {
  margin-bottom: 60px;
  margin-top: 50px;
}
.category-page .slider-wrapper .video-wrapper {
  padding: 100px 0;
}
@media (max-width: 768px) {
  .category-page .slider-wrapper {
    padding: 40px 0;
  }
  .category-page .slider-wrapper .video-wrapper {
    padding: 40px 0;
    padding-bottom: 0;
  }
  .category-page .slider-wrapper .slider {
    margin-top: 30px;
  }
}
a {
  text-decoration: none;
}
</style>
